export enum PlatformRegistrationType {
    Regular = 1,
    Guest = 2
}
